import React from 'react';
import { SparklesIcon, ChefHatIcon, HeartIcon, XIcon } from 'lucide-react';
export function UMPSection() {
  return <section className="py-20 bg-rose-50 relative overflow-hidden" data-id="element-345">
      <div className="container mx-auto px-4 relative z-10" data-id="element-346">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-347">
          <div className="flex-1" data-id="element-348">
            <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full text-rose-600 font-bold text-sm mb-6 shadow-sm" data-id="element-349">
              <SparklesIcon className="w-4 h-4" data-id="element-350" />
              <span data-id="element-351">El Método Secreto</span>
            </div>

            <h2 className="text-3xl lg:text-5xl font-serif font-bold text-gray-900 mb-6" data-id="element-352">
              Esto no es un recetario.
              <br data-id="element-353" />
              <span className="text-rose-500" data-id="element-354">
                Es un sistema anti-decisión.
              </span>
            </h2>

            <div className="bg-white/60 p-4 rounded-xl border border-rose-100 mb-6" data-id="element-355">
              <h4 className="font-bold text-gray-800 mb-2 flex items-center gap-2" data-id="element-356">
                <XIcon className="w-4 h-4 text-red-500" data-id="element-357" />
                Por qué un PDF común no funciona
              </h4>
              <p className="text-sm text-gray-600" data-id="element-358">
                Las recetas sueltas no resuelven la fatiga. Seguís teniendo que
                pensar qué elegir, qué comprar y si tenés tiempo. Seguís
                trabajando.
              </p>
            </div>

            <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-359">
              Este sistema está organizado por situación: ¿Estás cansada? ¿Tenés
              poco dinero? ¿No tenés tiempo? El sistema elige por vos. Opciones
              claras, rápidas y sabrosas.
            </p>

            <div className="space-y-6" data-id="element-360">
              <div className="flex gap-4" data-id="element-361">
                <div className="bg-white p-3 rounded-xl h-fit shadow-sm text-orange-500" data-id="element-362">
                  <ChefHatIcon className="w-6 h-6" data-id="element-363" />
                </div>
                <div data-id="element-364">
                  <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-365">
                    Sabor Real con Ritmo Latino
                  </h3>
                  <p className="text-gray-600" data-id="element-366">
                    Comida que sabe a hogar, no a dieta de hospital.
                    Ingredientes que ya tienes en tu alacena.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-367">
                <div className="bg-white p-3 rounded-xl h-fit shadow-sm text-orange-500" data-id="element-368">
                  <HeartIcon className="w-6 h-6" data-id="element-369" />
                </div>
                <div data-id="element-370">
                  <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-371">
                    Un Alivio Mental
                  </h3>
                  <p className="text-gray-600" data-id="element-372">
                    Un descanso en la toma de decisiones. Un botón de reinicio
                    para tus noches. La sensación de estar en control otra vez.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 relative" data-id="element-373">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-374">
              <img src="https://cdn.magicpatterns.com/uploads/4ehWuzAqCGmRhoX1zKFdQM/Ccocina07_30_28_p.m..png" alt="Madre e hijos cocinando felices" className="w-full h-auto object-cover" data-id="element-375" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent flex items-end p-8" data-id="element-376">
                <p className="text-white text-xl font-medium italic" data-id="element-377">
                  "Cuando tu cocina no pesa, tu vida se siente más liviana."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}